import waybillGroupFile1 from "./waybill-2022-12-12-15-51-18.pdf"
import waybillGroupFile2 from "./waybill-2022-12-12-15-54-33.pdf"
import waybillReport from "./5c4f8fea-7a10-11ed-978e-0242ac1c0003.xlsx"
export const bulkPdfListJson = {
    "data": [
        {
            "id": 2413,
            "group_id": "ccm۱۰۳۲۸۲in",
            "file_path": waybillGroupFile1,
            "pickup_from": 1670790600,
            "pickup_to": 1670790600,
            "provider":  "لینک اکسپرس",
            "order_count": 0,
            "created_at": 1670832216
        },
        {
            "id": 2412,
            "group_id": "ccm۱۰۳۲۸۲in",
            "file_path": waybillGroupFile2,
            "pickup_from": 1670790600,
            "pickup_to": 1670790600,
            "provider":  "اکوپیک",
            "order_count": 0,
            "created_at": 1670832163
        }
    ],
    "links": {
        "first": "http://portal.podro.com/api/orders/bulk/pdf/list?page=1",
        "last": "http://portal.podro.com/api/orders/bulk/pdf/list?page=1",
        "prev": null,
        "next": null
    },
    "meta": {
        "current_page": 1,
        "from": 1,
        "last_page": 1,
        "path": "http://portal.podro.com/api/orders/bulk/pdf/list",
        "per_page": 5,
        "to": 2,
        "total": 2
    }
}
export const orderReportsJson = {
    "data": [
        {
            "link": waybillReport,
            "status": "DONE",
            "createdAt": 1667978383
        },
        {
            "link": waybillReport,
            "status": "DONE",
            "createdAt": 1667740323
        },
        {
            "link": waybillReport,
            "status": "DONE",
            "createdAt": 1665408864
        },
        {
            "link": waybillReport,
            "status": "DONE",
            "createdAt": 1658734491
        },
        {
            "link": waybillReport,
            "status": "DONE",
            "createdAt": 1658649129
        }
    ],
    "meta": {
        "count": 5,
        "currentPage": 1,
        "lastPage": 4,
        "nextPageUrl": "http://portal.podro.com/api/orders/reports?page=2",
        "pageSize": 5,
        "total": 16
    }
}